// ENG2-2411: "Last activity" for a user-table row.
//
// A row is a dashboard user (userData, with last_login from the web DB), an API
// token (apiUserData, with last_used stamped by RisikaAPI), or a dashboard user
// who also holds a token. Activity is whichever of the two is more recent.

export interface LastActivityRow {
  userData?: { last_login?: string | null } | null
  apiUserData?: { last_used?: string | null; active?: boolean } | null
}

const toTime = (value?: string | null): number | null => {
  if (!value) return null
  const time = new Date(value).getTime()
  return Number.isNaN(time) ? null : time
}

/** The most recent of last_login and last_used as the original ISO string, or null. */
export const getLastActivity = (
  row?: LastActivityRow | null,
): string | null => {
  if (!row) return null
  const candidates = [row.userData?.last_login, row.apiUserData?.last_used]
  let best: string | null = null
  let bestTime = -Infinity
  for (const candidate of candidates) {
    const time = toTime(candidate)
    if (time !== null && time > bestTime) {
      best = candidate as string
      bestTime = time
    }
  }
  return best
}

/** True for rows that are only an API token (no dashboard user behind them). */
export const isApiOnlyRow = (row?: LastActivityRow | null): boolean =>
  !!row && !row.userData && !!row.apiUserData
